import { RouteRecordRaw } from 'vue-router'

const dockingRoutes: RouteRecordRaw[] = [
  {
    path: '/docking-lists',
    name: 'docking-lists.index',
    component: () => import('@/modules/docking/views/DockingListIndex.vue'),
    meta: {
      pageTitle: 'Docking Lists',
      breadcrumbs: ['Docking Lists']
    }
  },
  {
    path: '/docking-lists/:id/show',
    name: 'docking-lists.show',
    component: () => import('@/modules/docking/views/DockingListShow.vue'),
    meta: {
      pageTitle: 'Docking List Details',
      breadcrumbs: ['Docking Lists', 'Details']
    }
  }
]

export default dockingRoutes
